import { useResource } from "@/admin/useResource";
import {
  PageHeader,
  ResourceView,
  StatusBadge,
} from "@/admin/adminComponents";

const STATUS_OPTIONS = [
  { value: "active", label: "Active" },
  { value: "offline", label: "Offline" },
  { value: "pending_approval", label: "Pending Approval" },
  { value: "suspended", label: "Suspended" },
];

const columns = [
  { key: "id", label: "ID", render: (r) => <span className="font-mono text-xs">{r.id}</span> },
  { key: "name", label: "Rider", render: (r) => <span className="font-medium text-halalgo-ink">{r.name}</span> },
  { key: "phone", label: "Phone", render: (r) => <span className="whitespace-nowrap">{r.phone}</span> },
  { key: "city", label: "City" },
  { key: "vehicle", label: "Vehicle" },
  { key: "status", label: "Status", render: (r) => <StatusBadge value={r.status} /> },
  { key: "deliveries_count", label: "Deliveries" },
];

export default function Riders() {
  const { data, mocked, loading, refreshing, reload } = useResource("/riders", "riders");
  return (
    <div data-testid="admin-riders-page">
      <PageHeader title="Riders" subtitle="Delivery fleet status and performance." mocked={mocked} />
      <ResourceView
        columns={columns}
        rows={data}
        loading={loading}
        testId="riders-table"
        exportName="riders"
        onRefresh={reload}
        refreshing={refreshing}
        searchPlaceholder="Search by name, phone, city..."
        searchKeys={["id", "name", "phone", "city", "vehicle"]}
        filter={{ key: "status", placeholder: "Filter by status", allLabel: "All statuses", options: STATUS_OPTIONS }}
        detailTitle={(r) => r.name}
        detailSubtitle={(r) => `${r.vehicle} \u2022 ${r.city}`}
      />
    </div>
  );
}
